export const environment: any = (window as any)['environment']; // durch assets/environment.js gesetzt
